import { useDispatch, useSelector } from 'react-redux';
import { Filters } from '../interfaces';
import { exportTransactions, getPaymentMethodsForTrans, getTransactions, showExportTransactions } from './actions';
import { TransactionsSelectors } from './selectors';

export const useTransactions = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(TransactionsSelectors.getLoading),
    error: useSelector(TransactionsSelectors.getError),
    allTransactions: useSelector(TransactionsSelectors.getAllTransactions),
    export: useSelector(TransactionsSelectors.getExport),
    paymentMethods: useSelector(TransactionsSelectors.getPaymentMethods),
    getTransactions: (page?: number, filter?: Filters) => dispatch(getTransactions(page, filter)),
    getPaymentMethodsForTrans: (country: string) => dispatch(getPaymentMethodsForTrans(country)),
    showExportTransactions: (show: boolean) => dispatch(showExportTransactions(show)),
    exportTransactions: (filter: string) => dispatch(exportTransactions(filter)),
  };
};
